import { render, staticRenderFns } from "./SolutionPage2.vue?vue&type=template&id=6ffa1a4c&scoped=true"
import script from "./SolutionPage2.vue?vue&type=script&lang=js"
export * from "./SolutionPage2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ffa1a4c",
  null
  
)

export default component.exports